import { RouteObject } from 'src/app/core/interface'
import FundUpdates from 'src/app/home/pages/fund-updates'
import Overview from 'src/app/home/pages/overview'
import PortfolioNews from 'src/app/home/pages/portfolio-news'
import PortfolioNewsDetail from 'src/app/home/pages/portfolio-news/detail'
import WhyWeInvest from 'src/app/home/pages/why-we-invest'

import MemberInsights from '../pages/member-insights'

export const homeRoutes: RouteObject[] = [
  {
    path: '/',
    children: [
      { path: '/', element: <Overview />, isPrivate: true },
      { path: '/portfolio-news', element: <PortfolioNews />, isPrivate: true },
      {
        path: '/portfolio-news/:articleId',
        element: <PortfolioNewsDetail />,
        isPrivate: true,
      },
      {
        path: '/member-insights',
        element: <MemberInsights />,
        isPrivate: true,
      },
      { path: '/fund-updates', element: <FundUpdates />, isPrivate: true },
      {
        path: '/why-we-invest',
        element: <WhyWeInvest />,
        isPrivate: true,
      },
    ],
  },
]
